import React, { useCallback } from 'react';
import type { OrganizationListResponse } from '../../openapi/types';
import { useAppContext, useHistoryAction } from '../../hooks';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

export const OrganizationListItem: React.FC<OrganizationListResponse> = (props) => {
  const { appType } = useAppContext();
  const routeToOrganizationDetail = useHistoryAction('prejimkaOrganization', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('prejimkaOrganization' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }
      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToOrganizationDetail();
      }
    },
    [routeToOrganizationDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>{props.name}</td>
      <td>{props.ico}</td>
      <td>{props.dic}</td>
      <td>{`${props.street}, ${props.city}, ${props.postal_code}`}</td>
    </tr>
  );
};
